import { render, staticRenderFns } from "./UserCertificatePage.vue?vue&type=template&id=4a599bd2&scoped=true"
import script from "./UserCertificatePage.vue?vue&type=script&lang=js"
export * from "./UserCertificatePage.vue?vue&type=script&lang=js"
import style0 from "./UserCertificatePage.vue?vue&type=style&index=0&id=4a599bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a599bd2",
  null
  
)

export default component.exports